export const phoneNumber = '+84 868 911 000';
export const supportEmail = 'support@fiintrade.vn';

export const ZMFScorePDFUrl =
  'https://web.fiintrade.vn/media/hwpdpdsm/fiintrade_zmf-score-methodology_v1-0.pdf';

export const FACheckUpPDFUrl =
  'https://web.fiintrade.vn/media/g0xjnga3/fiintrade_fa-methodology_v1-0.pdf';

export const rankingPDFUrl =
  'https://web.fiintrade.vn/media/esmng1p2/fiintrade_ranking-methodology_v1-0.pdf';

export const scorePDFUrl =
  'https://web.fiintrade.vn/media/pktly4u2/fiintrade_scoring-methodology_v1-0.pdf';

export const tasignalPDFUrl =
  'https://web.fiintrade.vn/media/xyemshdk/fiintrade_technical-analysis-methodology_v1-1.pdf';

export const registerUrl = 'https://web.fiintrade.vn/dang-ki-tai-khoan/';

export const registerUrlEn = 'https://web.fiintrade.vn/en/sign-up/';

export const upgradeUrl = 'https://web.fiintrade.vn/chinh-sach-gia/';

export const upgradeUrlEn = 'https://web.fiintrade.vn/en/pricing/';

export const HOT_LINE = '0886911000';

export const TRADE_DATA_DOWNLOAD_LINK =
  'https://web.fiintrade.vn/tai-xuong-fiinta/';

export const TRADE_DATA_MANUAL_LINK_EN =
  'https://web.fiintrade.vn/media/abqnvkdc/h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-s%E1%BB%AD-d%E1%BB%A5ng-fiinta-ver2-0.pdf';
export const TRADE_DATA_MANUAL_LINK_VI =
  'https://web.fiintrade.vn/media/abqnvkdc/h%C6%B0%E1%BB%9Bng-d%E1%BA%ABn-s%E1%BB%AD-d%E1%BB%A5ng-fiinta-ver2-0.pdf';
